import { configValue } from 'config/appConfigUtils';

export function getStaticImageSrc(filePath: string): string {
  const imagesPath = configValue('idealist', 'staticImgPath');
  return `${imagesPath}${filePath}`;
}
